import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { withRouter } from 'react-router-dom';

import './dashHeader.css'

import * as firebase from 'firebase';

import LogoBot from '../../img/logoBot.png';

const auth = firebase.auth();

class Header extends Component {

    constructor(props){
        super(props);
        this.state = {
            clase: ''
        }
    }

    cambiarClase = async () => {
        let claseActual = await this.state.clase;

        if(!claseActual){
            await this.setState({clase: 'actualPagina'});
        }
    }

    cerrarSesion = (e) => {
        
        firebase.auth().signOut().then(function() {
            localStorage.removeItem('user');
          }).catch(function(error) {
            console.log('No se puede cerrar sesión' + error);
          });
    }

    render(){
        return(
            <div className='dashHead'>
                <div className='row barraHeader'>
                    <div className='col s12 m12 xl3 contImgHeader'>
                        <img className='imgHeader' src={LogoBot} alt='logoBot'/>
                    </div>
                    <div className='col s12 m12 xl9 navigationTop'>
                        <ul>
                            <li>
                                <Link to="/admin/dashboard/Estadisticas">Dashboard</Link>
                            </li>
                            <li>
                                <Link to="/admin/parametrizacion/Chatbot">Parametrización</Link>
                            </li>
                            <li>
                                <a href='#' onClick={this.cerrarSesion}>Cerrar Sesión</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(Header);